import { startTransition, StrictMode } from "react";
import { hydrateRoot, createRoot } from "react-dom/client";
import { HydratedRouter } from "react-router/dom";
import { msalInitPromise } from "./Auth/msalApp";
import { registerServiceWorker } from "./Utils/registerServiceWorker";

registerServiceWorker();

// Wait for MSAL to initialize before rendering the app
msalInitPromise.then(() => {
  startTransition(() => {
    hydrateRoot(
      document,
      <StrictMode>
        <HydratedRouter />
      </StrictMode>,
    );
  });
}).catch(error => {
  console.error("MSAL initialization failed:", error);
});
